export const headerConstant = {
    LIST_SUB_MENU: 'listSubMenu',
    DEFAULT_MODULE: '/dashboard',
    AUTHORITIES : "authorities",
    LIST_MENU: "listMenu",
};